export default "__VITE_ASSET__BvPfolZO__"